import {
    makeStyles,
    createStyles,
} from '@bb-ui/react-library/dist/components/styles';

export const useStyles = makeStyles(
    () =>
        createStyles({
            paper: {
                minHeight: '70vh',
            },
            title: {
                paddingBottom: '22px',
            },
            tabs: {
                paddingBottom: '2%',
                /**
                 * Wrap onto a second row instead of scrolling on a narrow
                 * screen, where the strip clipped "Authentication" down to
                 * "thenti" -- a label cut mid-word is worse than a taller tab
                 * strip. Selectors go through role rather than the MUI
                 * class names, because bb-ui renames those (MuiTabsflexContainer,
                 * not MuiTabs-flexContainer) and a class selector would silently
                 * match nothing.
                 */
                '& [role="tablist"]': {
                    flexWrap: 'wrap',
                },
                /*
                 * The scroller between the root and the tablist. It is an
                 * inline-block with `overflow-x: hidden`, which clips the second
                 * row; as a full-width block with visible overflow it grows with
                 * the wrapped rows instead.
                 */
                '& > div': {
                    display: 'block',
                    width: '100%',
                    overflow: 'visible',
                },
            },
        }),
    {
        name: 'UserSettings-',
    },
);
